import React from "react";
import MarkdownIt from "markdown-it";

// Create parser
const mdParser = new MarkdownIt({
  html: true,
  linkify: true, // just enables auto-linking, not _blank
  typographer: true,
  breaks: true,
});

// Override how links are rendered
const defaultRender =
  mdParser.renderer.rules.link_open ||
  function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
  };

mdParser.renderer.rules.link_open = function (
  tokens,
  idx,
  options,
  env,
  self
) {
  const token = tokens[idx];

  // Add target="_blank"
  const targetIndex = token.attrIndex("target");
  if (targetIndex < 0) {
    token.attrPush(["target", "_blank"]);
  } else {
    token.attrs[targetIndex][1] = "_blank";
  }

  // Add rel="noopener"
  const relIndex = token.attrIndex("rel");
  if (relIndex < 0) {
    token.attrPush(["rel", "noopener"]);
  } else {
    token.attrs[relIndex][1] = "noopener";
  }

  return defaultRender(tokens, idx, options, env, self);
};

const PRESERVE_NEWLINE = '<!--__MD_EMPTY_LINE__-->';

function preserveEmptyLines(text = '') {
  return text
    .replace(/\r\n/g, '\n')
    .replace(/\n{2,}/g, match =>
      '\n' + PRESERVE_NEWLINE.repeat(match.length - 1) + '\n'
    );
}

export default function MarkdownViewer({ content }) {
  let html = mdParser.render(preserveEmptyLines(content || ''));

  html = html
    .replace(new RegExp(PRESERVE_NEWLINE, 'g'), '<br />')
    .replace(/\+\+(.+?)\+\+/g, '<u>$1</u>');

  return (
    <div
      className="custom-html-style custom-react-markdown"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
